[
  {
    "id": "a1b2c3d4-e5f6-4a7b-8c9d-0e1f2a3b4c5d",
    "gtin": "01000019",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "C7L5",
    "isNew": false,
    "status": "COMPLETED"
  },
  {
    "id": "b2c3d4e5-f6a7-4b8c-9d0e-1f2a3b4c5d6e",
    "gtin": "01000022",
    "action": "CHECK",
    "stockLevel": "NO_STOCK",
    "shelfId": "OP85",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "c3d4e5f6-a7b8-4c9d-0e1f-2a3b4c5d6e7f",
    "gtin": "01000025",
    "action": "CHECK",
    "stockLevel": "NO_STOCK",
    "shelfId": "ZK8K",
    "isNew": false,
    "status": "OPEN"
  },
  {
    "id": "d4e5f6a7-b8c9-4d0e-1f2a-3b4c5d6e7f8a",
    "gtin": "01000028",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "NME1",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "e5f6a7b8-c9d0-4e1f-2a3b-4c5d6e7f8a9b",
    "gtin": "01000031",
    "action": "CHECK",
    "stockLevel": "NO_STOCK",
    "shelfId": "AC64",
    "isNew": false,
    "status": "COMPLETED"
  },
  {
    "id": "f6a7b8c9-d0e1-4f2a-3b4c-5d6e7f8a9b0c",
    "gtin": "01000034",
    "action": "CHECK",
    "stockLevel": "NO_STOCK",
    "shelfId": "2B3W",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "a7b8c9d0-e1f2-4a3b-4c5d-6e7f8a9b0c1d",
    "gtin": "01000037",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "N2I9",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "b8c9d0e1-f2a3-4b4c-5d6e-7f8a9b0c1d2e",
    "gtin": "01000040",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "UNMG",
    "isNew": false,
    "status": "OPEN"
  }
]